/**
 * Footer link kuralları — `www.paribu.com` footer'ıyla (micro-web `apps/footer`)
 * aynı hedefleri üretir. Bu dosya olmadan destek sitesi kendi kopyasını taşıyor
 * ve her SEO turunda ayrışıyordu.
 */

const TR_MAP: Record<string, string> = {
  ç: 'c',
  ş: 's',
  ğ: 'g',
  ü: 'u',
  ö: 'o',
  ı: 'i',
  Ç: 'c',
  Ş: 's',
  Ğ: 'g',
  Ü: 'u',
  Ö: 'o',
  İ: 'i',
}
const TR_RE = /[çşğüöıÇŞĞÜÖİ]/g

/**
 * LSSR `slugify` ile BİREBİR aynı olmalı: üretilen URL o tarafın kanonik
 * yazımıdır. Noktayı atmayan eski sürüm `/fiyat/pump.fun` basıyordu — 400.
 */
export function slugify(name: string): string {
  return name
    .toLowerCase()
    .replace(TR_RE, (ch) => TR_MAP[ch] ?? ch)
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}

/**
 * Pegli varlıklar footer listelerinde gösterilmez (SEO isteği). Küme AÇIK
 * yazılmak ZORUNDA: `labels: ['stable']` üretimde hiçbir piyasada gelmiyor,
 * yani etikete bakan filtre hiç çalışmıyordu.
 */
export const PEGGED_BASES = new Set(['usdt', 'usdc', 'xaut', 'gram', 'tryc'])

const SITE = 'https://www.paribu.com'

/**
 * Ana sitenin fiyat sayfaları İngilizce'de `/en` önekiyle açılıyor; TR varsayılan
 * dil, öneksiz. Blog, hub ve destek ayrı sistemler, onların `/en`'i yok.
 */
const siteFor = (locale?: string): string => (locale === 'en' ? `${SITE}/en` : SITE)

/**
 * Kanonik dönüştürücü URL'i. `btc-to-tl` biçimi tutarlı değil — canonical
 * `1-<slug>-kac-tl`, İngilizce'de `1-<slug>-in-try` (LSSR başka her şeyi 301'ler).
 */
export const converterUrl = (fullName: string, locale?: string): string =>
  `${siteFor(locale)}/converter/1-${slugify(fullName)}${locale === 'en' ? '-in-try' : '-kac-tl'}`

export const priceUrl = (fullName: string, locale?: string): string =>
  `${siteFor(locale)}/fiyat/${slugify(fullName)}`
export const predictionUrl = (fullName: string, locale?: string): string =>
  `${siteFor(locale)}/fiyat-tahmini/${slugify(fullName)}`
export const priceHistoryUrl = (slug: string, locale?: string): string =>
  `${siteFor(locale)}/gecmis-fiyat-performansi/${slug}`

/** Apex `paribu.com` www'ya 301 veriyor — footer her sayfada 11 yönlendirme taşıyordu. */
export const legalUrl = (slug: string): string => `${SITE}/destek/yasal/${slug}`

export const LEGAL_SLUGS = [
  ['company_info', 'sirket-bilgileri'],
  ['pre_contract_info_form', 'cerceve-sozlesme-oncesi-genel-bilgilendirme-formu'],
  ['user_framework_agreement', 'kripto-varlik-hizmetleri-cerceve-sozlesmesi'],
  ['general_risk_notice', 'genel-risk-bildirim-formu'],
  ['special_risk_notice', 'ozel-risk-bildirim-formu'],
  [
    'customer_info_text',
    'paribu-kripto-varlik-alim-satim-platformu-as-musterilere-iliskin-aydinlatma-metni',
  ],
  [
    'customer_consent_text',
    'paribu-kripto-varlik-alim-satim-platformu-as-musterilere-iliskin-acik-riza-metni',
  ],
  ['business_continuity', 'is-surekliliginin-saglanmasi-ve-acil-durum-iletisim-bilgileri'],
  [
    'electronic_communication',
    'musteriye-elektronik-ortamda-yapilacak-bildirimlere-iliskin-esaslar',
  ],
  ['legal_notifications', 'yasal-bildirimler'],
  ['legal_information', 'yasal-bilgilendirme-metinlerine-ve-sozlesmelere-nasil-ulasabilirim'],
] as const

export const isOffsite = (url: string): boolean =>
  /^https?:\/\//i.test(url) && !url.startsWith(SITE)
